import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-add",
  "use": "icon-icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-add\"><!--Generator: Adobe Illustrator 29.0.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 186)--><path d=\"M900.19,452h-328.09V123.91c0-33.14-26.86-60-60-60h0c-33.14,0-60,26.86-60,60v328.09H124.01c-33.14,0-60,26.86-60,60h0c0,33.14,26.86,60,60,60h328.09v328.09c0,33.14,26.86,60,60,60h0c33.14,0,60-26.86,60-60v-328.09h328.09c33.14,0,60-26.86,60-60h0c0-33.14-26.86-60-60-60Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol